export * from './VATLegalMentions';
